module.exports = __webpack_public_path__ + "static/media/order_devil_transparent.73756ea6.png";